import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatDrawerMode, MatSidenavModule } from '@angular/material/sidenav';
import { SlidebarComponent } from '@core/shell/layouts/layout-vertical/components/slidebar/slidebar.component';
import { ToolbarComponent } from '@core/shell/layouts/layout-vertical/components/toolbar/toolbar.component';
import { debounceTime, fromEvent, Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-layout-vertical',
  standalone: true,
  imports: [MatSidenavModule, SlidebarComponent, ToolbarComponent,MatIconModule],
  templateUrl: './layout-vertical.component.html',
  styleUrl: './layout-vertical.component.scss',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutVerticalComponent implements OnInit, OnDestroy {
  isShowSlideBar: boolean = true;
  mode: MatDrawerMode = 'side';
  changeShowSlidebar = () => {
    this.isShowSlideBar = !this.isShowSlideBar;
  };
  resizeSubscription?: Subscription;

  ngOnInit() {
    // Only run in browser (not during SSR)
    if (typeof window !== 'undefined') {
      this.measure();
      if(window.innerWidth <= 767) this.isShowSlideBar = false
      this.resizeSubscription = fromEvent(window, 'resize')
        .pipe(debounceTime(200))
        .subscribe((event: Event) => {
          this.measure();
        });
    }
  }

  measure = () => {
    // Only run in browser (not during SSR)
    if (typeof window === 'undefined') return;
    
    if (window.innerWidth <= 767 && this.mode === 'side') {
      this.mode = 'over';
    } else if (window.innerWidth > 767 && this.mode === 'over') {
      this.mode = 'side';
    }
  };

  ngOnDestroy() {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }
}
